import React from 'react'

export function ArrowPrevStopIcon() {
  return (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title>ico_arrow_prestop</title>
      <g
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <polyline
          stroke="#FFFFFF"
          strokeWidth="2.7"
          points="17.624 5.2363 10.86 12.0003 17.624 18.7633"
        ></polyline>
        <line
          x1="6.3408"
          y1="5.2363"
          x2="6.3408"
          y2="18.7633"
          stroke="#FFFFFF"
          strokeWidth="2.7"
        ></line>
      </g>
    </svg>
  )
}
